import {
  ILibraryManifestContext,
  ILibraryAssetsPatterns,
  IRegistryManifestContext,
  IWebpackManifestContext,
} from '../registry.types';
import { createInternalException } from '../errors/RegistryError';
import { parseWebpackManifest } from './parseWebpackManifest';
import { parseRegistryManifest } from './parseRegistryManifest';

export { parseRegistryManifest, parseWebpackManifest };

const isRegistryManifest = (
  library: IWebpackManifestContext | IRegistryManifestContext,
): library is IRegistryManifestContext => {
  return (
    library.hasOwnProperty('topology') &&
    library.hasOwnProperty('manifest') &&
    library.manifest.hasOwnProperty('version')
  );
};

const isWebpackManifest = (
  library: IWebpackManifestContext | IRegistryManifestContext,
): library is IWebpackManifestContext => {
  return (
    library.hasOwnProperty('topology') && library.hasOwnProperty('manifest')
  );
};

export function parseManifest(
  library: IWebpackManifestContext | IRegistryManifestContext,
  libraryAssetsPatterns: ILibraryAssetsPatterns = [],
): ILibraryManifestContext {
  if (isRegistryManifest(library)) {
    return parseRegistryManifest(library);
  } else if (isWebpackManifest(library)) {
    return parseWebpackManifest(library, libraryAssetsPatterns);
  } else {
    throw createInternalException();
  }
}
